import React from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';

import { VideoCategory } from '../../../../types';
import { DEFAULT_URL } from '../../const';
import { CategoryLink } from '../CategoryLink';
import useStyles from './styles';

interface SubcategoriesBlockProps {
  categorySlug?: string | null;
  childCategories?: VideoCategory[] | null;
  wrapperClass?: string;
}

const SubcategoriesBlock: React.FC<SubcategoriesBlockProps> = ({
  categorySlug,
  childCategories,
  wrapperClass,
}) => {
  const classes = useStyles();

  return childCategories ? (
    <Box className={cx(classes.categoriesWrapper, wrapperClass)}>
      {childCategories.map((item) => (
        <CategoryLink
          key={item?.slug}
          link={`${DEFAULT_URL}/${categorySlug}/${item?.slug}`}
          title={item?.title}
        />
      ))}
    </Box>
  ) : null;
};

export default SubcategoriesBlock;
